import React from 'react';
import './Sucesso.css';

export default function Sucesso({ result, onNovaScan }) {
  const { empresa, tipoDoc, dados, resultados } = result || {};
  const destinos = Object.keys(resultados || {}).join(', ').toUpperCase();

  return (
    <div className="sucesso-page">
      <div className="sucesso-icon">✓</div>
      <h2 className="sucesso-title">Documento entregue</h2>
      <p className="sucesso-sub">
        {tipoDoc} · {empresa}<br />
        {dados?.entidade && <span>{dados.entidade}<br /></span>}
        {dados?.montante && <span>{dados.montante}<br /></span>}
        <span style={{fontSize:'11px', opacity:0.7}}>Enviado para: {destinos || '—'}</span>
      </p>
      <div className="sucesso-actions">
        <button className="sucesso-primary" onClick={onNovaScan}>
          ◎ Novo scan
        </button>
      </div>
    </div>
  );
}
